module.exports = __webpack_public_path__ + "media/components/dashboard/icons/client-dd6d8a162138d91f9513501cbe4e3097.svg";